module.exports = __webpack_public_path__ + "img/002.91487eb9.png";